function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5DC6F6",
  fillRule: "nonzero",
  stroke: "#5DC6F6",
  strokeWidth: .2,
  d: "M1.178 13.993l3.722-3.7L1.386 6.77a.575.575 0 0 1 0-.832c.832-.803 1.897-1.249 3.026-1.249.534 0 1.068.089 1.571.298l3.797-3.81a.575.575 0 0 1 .831 0l4.211 4.193a.575.575 0 0 1 0 .831l-3.825 3.836c.623 1.575.243 3.335-.949 4.578-.225.235-.668.223-.831 0l-3.5-3.51-3.708 3.716a.575.575 0 0 1-.831 0 .572.572 0 0 1 0-.829z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-pin.690d733e.svg";
export { SvgComponent as ReactComponent };